export const maxAge = 130;

export const maxDate = (() => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
})();

export const minDate = (() => {
  const date = new Date();
  date.setFullYear(maxDate.getFullYear() - maxAge);
  return date;
})();
